export default "__VITE_ASSET__5d4253b1__"